import { FC } from 'react';
import { formatCurrency } from '../../../../utils/currency';
import type { ClientSummary as ClientSummaryType } from '../../../../types/therapist-dashboard.types';

interface ClientSummaryProps {
  clients: ClientSummaryType[];
}

export const ClientSummary: FC<ClientSummaryProps> = ({ clients }) => {
  const totalAppointments = clients.reduce((sum, c) => sum + c.totalAppointments, 0);
  const totalRevenue = clients.reduce((sum, c) => sum + c.totalSpent, 0);
  const avgPerClient = clients.length > 0 ? totalRevenue / clients.length : 0;

  return (
    <div className="bg-gray-50 dark:bg-slate-800/50 rounded-lg p-4 border border-gray-200 dark:border-slate-700">
      <h3 className="font-medium text-gray-900 dark:text-slate-100 mb-3">Client Summary</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
        <div>
          <p className="text-gray-500 dark:text-slate-400">Total Clients</p>
          <p className="text-xl font-bold text-gray-900 dark:text-slate-100">{clients.length}</p>
        </div>
        <div>
          <p className="text-gray-500 dark:text-slate-400">Total Appointments</p>
          <p className="text-xl font-bold text-gray-900 dark:text-slate-100">{totalAppointments}</p>
        </div>
        <div>
          <p className="text-gray-500 dark:text-slate-400">Total Revenue</p>
          <p className="text-xl font-bold text-green-600 dark:text-green-400">
            {formatCurrency(totalRevenue)}
          </p>
        </div>
        <div>
          <p className="text-gray-500 dark:text-slate-400">Avg per Client</p>
          <p className="text-xl font-bold text-gray-900 dark:text-slate-100">
            {formatCurrency(avgPerClient)}
          </p>
        </div>
      </div>
    </div>
  );
};
